import React from 'react'

interface PaginationProps {
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
}

export const Pagination: React.FC<PaginationProps> = ({ currentPage, totalPages, onPageChange }) => {
  const canGoPrevious = currentPage > 1
  const canGoNext = currentPage < totalPages

  if (totalPages <= 1) return null

  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1)

  return (
    <div className="flex items-center justify-center gap-0 my-4">
      <button
        onClick={() => canGoPrevious && onPageChange(currentPage - 1)}
        disabled={!canGoPrevious}
        className={`w-8 h-8 flex items-center justify-center rounded-l-lg border border-gray-200 ${
          canGoPrevious ? 'bg-white hover:bg-gray-50 cursor-pointer' : 'bg-gray-100 cursor-not-allowed opacity-50'
        }`}
      >
        <span className="text-gray-600">‹</span>
      </button>

      {pageNumbers.map((page) => (
        <button
          key={page}
          onClick={() => onPageChange(page)}
          className={`w-8 h-8 flex items-center justify-center border-y border-r border-gray-200 text-xs ${
            page === currentPage ? 'bg-black text-white' : 'bg-white text-gray-600 hover:bg-gray-50 cursor-pointer'
          }`}
        >
          {page}
        </button>
      ))}

      <button
        onClick={() => canGoNext && onPageChange(currentPage + 1)}
        disabled={!canGoNext}
        className={`w-8 h-8 flex items-center justify-center rounded-r-lg border border-gray-200 ${
          canGoNext ? 'bg-white hover:bg-gray-50 cursor-pointer' : 'bg-gray-100 cursor-not-allowed opacity-50'
        }`}
      >
        <span className="text-gray-600">›</span>
      </button>
    </div>
  )
}
